import BaseMethods from './base.js';

class MyPrint {
	constructor(obj) {
		let dpi = BaseMethods.getDpi()[0];
		var containerDom = obj.container,
			a4Dom = document.createElement('div'),
			tableDom = '',
			rowDom = '',
			pageNum = 1,
			isRotate = obj.isRotate ? true : false,
			verticalPadding = MyPrint.verticalPadding,
			crossPadding = MyPrint.crossPadding,
			table = obj.table || null,
			tableHead = obj.tableHead || '';
			
		if (isRotate) {
			MyPrint.A4Width = Math.floor(297 / 25.4 * dpi);
			MyPrint.A4Height = Math.floor(210 / 25.4 * dpi) - 1;
		} else {
			MyPrint.A4Width = Math.floor(210 / 25.4 * dpi) - 1;
			MyPrint.A4Height = Math.floor(297 / 25.4 * dpi);
		}
		
		a4Dom.className = 'a4_page';
		a4Dom.style = `width: ${ MyPrint.A4Width }px;min-height: ${ MyPrint.A4Height }px;`;
		a4Dom.style.padding = `${ verticalPadding }px ${ crossPadding }px`;
		a4Dom.style.border = '1px solid #ccc';
		
		this._containerDom = containerDom;	// 最外层的大容器
		this._a4Dom = a4Dom;	// 每一张a4纸的容器
		this._tableDom = tableDom;	// 每一个table容器
		this._rowDom = rowDom;	// 每一行
		this._pageNum = pageNum;	// 页码
		this._isRotate = isRotate;	// 是否横屏打印
		this._verticalPadding = verticalPadding;	// 每一张a4纸纵向内边距
		this._crossPadding = crossPadding;	// 每一张a4纸横向内边距
		this._table = table;	// 存储初始化的table
		this._tableHead = tableHead;	// table头部
		
		this._containerDom.innerHTML = '';
		this._containerDom.appendChild(this._a4Dom);
		this._addNumber();
	}

	static A4Width = 794;
	static A4Height = 1090;
	static verticalPadding = 72;
	static crossPadding = 54;
	
	// 添加每一行
	addRow(domObj) {
		const that = this;
		that._rowDom = document.createElement(domObj.tag);
		domObj.className && (that._rowDom.className = domObj.className);
		domObj.style && (that._rowDom.style = domObj.style);
		domObj.attrs && domObj.attrs.forEach(item => {
			that._rowDom.setAttribute(item.name, item.value);
		});
		domObj.htmlStr && (that._rowDom.innerHTML = domObj.htmlStr);
		domObj.tableRemove && (that._tableDom = '');
		domObj.tableRequired && that._setTable(domObj.table);
		domObj.tableRequired && that._addTable(domObj);
		that._addRowDom();
		that._checkOverFlow(domObj);
	}
	
	// 移除当前行
	_removeRow() {
		this._tableDom
		? (this._tableDom.removeChild(this._rowDom))
		: (this._a4Dom.removeChild(this._rowDom));
		if (this._tableDom && !this._tableDom.innerHTML) {
			this._a4Dom.removeChild(this._tableDom);
		}
	}
	
	// 还原需要数据
	_restoreData() {
		this._a4Dom = '';
		this._tableDom = '';
	}
	
	// 添加新的页
	_addPage(domObj) {
		var a4Dom = document.createElement('div');
			
		a4Dom.className = 'a4_page';
		a4Dom.style = `width: ${ MyPrint.A4Width }px;min-height: ${ MyPrint.A4Height }px;`;
		a4Dom.style.padding = `${ this._verticalPadding }px ${ this._crossPadding }px`;
		a4Dom.style.border = '1px solid #ccc';
		this._pageNum++;
		
		this._a4Dom = a4Dom;
		this._containerDom.appendChild(this._a4Dom);
		domObj.tableRequired && this._setTable(domObj.table);		domObj.tableRequired && this._addTable(domObj);
		this._addNumber();
		this._addRowDom();
	}
	
	// 设置table
	_setTable(tableOption) {
		var	tableDom = '';
		
		if (tableOption) {
			tableDom = document.createElement(tableOption.tag);
			tableOption.className && (tableDom.className = tableOption.className);
			tableOption.style && (tableDom.style = tableOption.style);
			tableOption.attrs && tableOption.attrs.forEach(item => {
				tableDom.setAttribute(item.name, item.value);
			});
		} else if (this._table) {
			tableDom = document.createElement(this._table.tag);
			this._table.className && (tableDom.className = this._table.className);
			this._table.style && (tableDom.style = this._table.style);
			this._table.attrs && this._table.attrs.forEach(item => {
				tableDom.setAttribute(item.name, item.value);
			});
		}

		this._tableDom = tableDom;
	}
	
	// 添加table
	_addTable(domObj) {
		this._tableDom && this._a4Dom.appendChild(this._tableDom);
		if (this._tableDom && this._tableHead && domObj.hasTableHead) {
			this._tableDom.innerHTML = this._tableHead;
		}
	}
	
	// 添加每一行
	_addRowDom() {
		if (this._tableDom) {
			this._tableDom.appendChild(this._rowDom);
		} else {
			this._a4Dom.appendChild(this._rowDom)
		}
	}
	
	// 添加页码
	_addNumber() {
		var numDom = document.createElement('p');
		numDom.className = 'a4_number';
		numDom.innerText = `- ${ this._pageNum } -`;
		this._a4Dom.appendChild(numDom);
	}
	
	// 检查是否超过A4纸的大小
	_checkOverFlow(domObj) {
		var height = this._a4Dom.offsetHeight;
		if (height > MyPrint.A4Height) {
			this._tableDom && (domObj.tableRequired = true);
			this._removeRow();
			this._restoreData();
			this._addPage(domObj);
		}
	}
}

export default MyPrint;